var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"mr-1",class:[_vm.estilo, _vm.loading ? 'fa-spinner fa-spin' : _vm.icono]})}
var staticRenderFns = []

export { render, staticRenderFns }